import { render, staticRenderFns } from "./TermsPt.vue?vue&type=template&id=20bb11b0"
import script from "./TermsPt.vue?vue&type=script&lang=js"
export * from "./TermsPt.vue?vue&type=script&lang=js"
import style0 from "./TermsPt.vue?vue&type=style&index=0&id=20bb11b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports